import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_388: DocMigration = {
  maxSchemaVersion: "0.0.388",
  description: "Add selection method to view template overrides",
  apply(json: any) {
    for (const viewTemplateOverrideId in json.viewTemplateOverrides) {
      json.viewTemplateOverrides[viewTemplateOverrideId].selectionMethod = "BY_TAG";
    }

    return json;
  },
};

export default migration_0_0_388;
